// extracted by mini-css-extract-plugin
export default {"Octicon":"ImmutableActionsHasUnmigratableTagsDialog-module__Octicon--niEHA"};